import React from "react";
import { getToken } from "../utils/authHelper";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, allowedRoles }) => {
  const location = useLocation();
  const token = getToken();
  const userRole = useSelector((state) => state?.auth?.user?.user_type);

  if (!token)
    return <Navigate to="/recruiter" state={{ from: location }} replace />;
  if (!allowedRoles.includes(userRole))
    return <Navigate to="/unauthorized" replace />;

  return children;
};

export default PrivateRoute;
